module.exports = require("antd");